import Card from "react-bootstrap/Card";
import './custom2.css';

export function Recommendations({ recommendations }) {
    const data = "This is data from Child Component to the Parent Component."
    const ulStyle = { width: '100%', listStyleType: 'none',padding:'0px' }
    const liStyle = { color: 'black', fontSize: '16px', borderBottom: '1px solid #eee',padding:'10px',margin:"10px" }
  
    let changedr = new Array();
    for(var k in recommendations){
        changedr.push({key:k,value:recommendations[k]})
    }
    changedr=changedr.sort((a,b)=>a.value[11]<b.value[11]?1:-1)
    recommendations=changedr;

    function recommPriority(skup){
      switch(skup){
        case 1:
          return "Crosssell";
        case 2:
           return "Upsell";
        default:
          return skup;
      }
    }
    
    return (
      
      <ul style={ulStyle}>
        {recommendations.map((v, index) => {
          return <li key={index} style={liStyle} className="card">
            <div>Type:<span style={v.value.recommendationType =="extra" ? { color: 'red' } : { color: 'green' }}>{v.value.recommendationType} {recommPriority(v.value.skuPriority)}</span></div>
            <table className="cattable">
              <tr><th>SKU</th><th>Amount</th><th>Quantity</th></tr>
              <tr><td>{v.value.skuCode}</td><td>{v.value.totalAmount}</td><td>{v.value.pieceQuantity}</td></tr>

            </table>
            
          </li>
        })}
      </ul>
      
    )
  }
  
  export function RecommendationSummary({ recommendations,recordInfo }) {
    const data = "This is data from Child Component to the Parent Component."
    const ulStyle = { width: '100%', listStyleType: 'none' }
    const liStyle = { color: 'black', fontSize: '16px', borderBottom: '1px solid #eee' }
  
    // let changedr = new Array();
    // for(var k in recommendations){
    //     changedr.push({key:k,value:recommendations[k]})
    // }
    // recommendations=changedr;

    // const summary = recommendations.filter(s => s.value[5] > 1).reduce((acc, cur) => {
    //   return [acc[0] + cur.value[6], acc[1] + cur.value[7]]
    // }, [0, 0]);
  
    return (
      <>
        <Card style={{margin:"10px"}}>
          <Card.Body>
            <Card.Title style={{ color: "green" }}>Summary</Card.Title>
            <Card.Subtitle className="mb-2 text-muted">
            </Card.Subtitle>
            <Card.Text>
  
            </Card.Text>
            <ul style={ulStyle}>
              {/* <li>
                ClusterInfo : {JSON.stringify(recommendations)}
              </li> */}
              <li>
                Total Items : {recommendations.length}
              </li>
              <li>
                Total Upsell Quantity : {recommendations.filter(a=>a.recommendationType=="extra" && a.skuPriority==2 ).reduce((a, b) => a + b.pieceQuantity, 0)}
              </li>
              <li>
                Total Crossell Quantity : {recommendations.filter(a=>a.recommendationType=="extra" && a.skuPriority==1).reduce((a, b) => a + b.pieceQuantity, 0)}
              </li>
              <li>
                Total Quantity : {recommendations.reduce((a, b) => a + b.pieceQuantity, 0)}
              </li>
              <li>
                Total Amount : {recommendations.reduce((a, b) => a + b.otherQuantity, 0)}
              </li>
            </ul>
          </Card.Body>
        </Card>
  
      </>
  
    )
  }
  